export enum IEventRoleOptions {
  ATTENDEE = 'ATTENDEE',
  ORGANIZER = 'ORGANIZER',
  SPEAKER = 'SPEAKER',
  SPONSOR = 'SPONSOR',
  MODERATOR='MODERATOR',
}
